import { cn } from '@/lib/utils';
import { type VariantProps, cva } from 'class-variance-authority';

const notificationCountBadgeVariants = cva(
    'inline-flex justify-center items-center bg-notification px-1 rounded-full font-medium tabular-nums text-notification-foreground',
    {
        variants: {
            size: {
                default: 'min-w-6 h-6 text-sm',
                sm: 'min-w-5 h-5 text-xs leading-none'
            }
        },
        defaultVariants: {
            size: 'default'
        }
    }
);

interface NotificationCountBadgeProps
    extends VariantProps<typeof notificationCountBadgeVariants> {
    count: number;
    max?: number;
    className?: string;
}

export function NotificationCountBadge({
    count,
    max = 99,
    size,
    className
}: NotificationCountBadgeProps) {
    if (count <= 0) return null;
    const display = count > max ? `${max}+` : String(count);

    return (
        <span
            className={cn(notificationCountBadgeVariants({ size }), className)}
            aria-label={`${count} unread`}
        >
            {display}
        </span>
    );
}
